import React, { useEffect } from "react";

const REDIRECT_URL = "https://learn.indiemusiccreators.com/web/checkout/693d94d13f8595dac5bd62db?couponcode=TODAYONLY&purchaseNow=true";

const Special = () => {
  useEffect(() => {
    window.location.replace(REDIRECT_URL);
  }, []);
  return (
    <div style={{ display: "none" }} />
  );
};

export default Special;
